import { styled } from '../../shared/theming-sc'

const DatatableOuter = styled.div`
    position: relative;
`

const ScrollerPlaceholder = styled.div`
    height: 56px;
`

const LoaderWrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 100%%;
    clear: both;
`

export {
  DatatableOuter,
  ScrollerPlaceholder,
  LoaderWrapper
}
